var app = require('application')

/**
 * HELPERS POUR LES DATES
 */

/**
 * Renvoi l'année courante
 * @author Quentin JANON <qjanon@absystech.fr>
 * @param
 * @return date   Format YYYY
 */
Handlebars.registerHelper('currentYear', function () {
  return moment().format('YYYY')
})
Handlebars.registerHelper('logger', function (str) {
  console.log(str)
})

Handlebars.registerHelper('ifDatePassee', function (dat, options) {
  let date = moment(dat, 'YYYY-MM-DD HH:mm:ss')
  let now = moment()

  if (now.diff(date) > 0) {
    return options.fn(this)
  }
  return options.inverse(this)
})

Handlebars.registerHelper('times', (n, block) => {
  let accum = ''
  for (let i = 0; i < n; ++i) {
    accum += block.fn(i)
  }
  return accum
})

Handlebars.registerHelper('rtimes', (n, block) => {
  let accum = ''
  for (let i = n; i > 0; --i) {
    accum += block.fn(i)
  }
  return accum
})

Handlebars.registerHelper('fromNow', function (timestamp) {
  if (timestamp && timestamp !== ' ') {
    if (moment().diff(timestamp, 'days') <= 1 && moment().diff(timestamp, 'days') >= -1) {
      return moment().calendar(timestamp, {
        sameDay: '[Aujourd\'hui]',
        nextDay: '[Demain]',
        nextWeek: 'Semaine prochaine',
        lastDay: '[Hier]',
        lastWeek: '[Semaine dernière]',
        sameElse: 'DD/MM/YYYY'
      })
    } else {
      let d = moment(timestamp).fromNow()
      return d.charAt(0).toUpperCase() + d.slice(1)
    }
  }
})

Handlebars.registerHelper('upper', function (str) {
  if (str) {
    return str.toUpperCase()
  }
})

Handlebars.registerHelper('nl2br', function (word) {
  word = word || ''
  return new Handlebars.SafeString(word.replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '<br>'))
})

Handlebars.registerHelper('toFrench', function (timestamp, chiffre) {
  if (timestamp && timestamp !== ' ') {
    if (typeof chiffre !== 'object') {

      return moment(timestamp).format('DD') + '/' + moment(timestamp).format('MM') + '/' + moment(timestamp).format('Y')
    } else {
      return moment(timestamp).calendar()
    }
  }
})

Handlebars.registerHelper('toFrenchDay', function (timestamp) {
  if (timestamp) {
    moment.relativeTimeThreshold('d', 80000)
    return moment(timestamp).fromNow()
  }
})

Handlebars.registerHelper('now', function (f) {
  if (typeof f === 'object') f = 'YYYY-MM-DD'
  return moment().format(f)
})

Handlebars.registerHelper('month', function (v) {
  return moment(v).format('MMM')
})
Handlebars.registerHelper('day', function (v) {
  return moment(v).format('DD')
})

Handlebars.registerHelper('year', function (v) {
  return moment(v).format('Y')
})

// Ajouter les classes bootstrap hidden des devices
Handlebars.registerHelper('dateFormat', function (date, f) {
  if (typeof f === 'object') f = 'YYYY-MM-DD'

  return moment(date).format(f)
})

/**
 * HELPERS POUR LE RESTE
 */

// Appliquer une localisation
Handlebars.registerHelper('i18n', function (word, prefix, suffix, strict, suffixInPrefix) {
  word = app.i18n().trans(word, prefix, suffix, strict, suffixInPrefix)
  return new Handlebars.SafeString(word)
})

// Cookies
Handlebars.registerHelper('cookie', function (key) {
  return $.cookie(key)
})
Handlebars.registerHelper('ifCookie', function (key, options) {
  if ($.cookie(key)) {
    return options.fn(this)
  }
  return options.inverse(this)
})

// Mettre en valeur un terme
Handlebars.registerHelper('highlight', function (s, kw) {
  var mots = kw.toLowerCase().split(' ')
  for (var idx in mots) {
    s = s.replace(new RegExp('(' + mots[idx] + ')', 'gi'), '<span class="highlight">$1</span>')
  }
  return new Handlebars.SafeString(s)
})

// Affiche uniquement la 1ere lettre
Handlebars.registerHelper('FirstLetterOnly', function (str, coma) {
  if (str) {
    return str.substring(0, 1) + (coma !== false ? '.' : '')
  }
})

// Multiplication
Handlebars.multiply = function () {
  var result = 1.0
  for (var i = 0; i < arguments.length; i++) {
    if (typeof arguments[i] !== 'object') { result *= arguments[i] }
  }
  return result
}
Handlebars.registerHelper('multiply', Handlebars.multiply)
Handlebars.registerHelper('multiplyToEuros', function () {
  return Handlebars.euros(Handlebars.multiply.apply(this, arguments), 2, ',')
})

Handlebars.registerHelper('inArray', function (array, value) {
  var options = arguments[arguments.length - 1]
  if (!array) return false
  if (array.find((obj) => parseInt(obj) === parseInt(value))) {
    return options.fn(this)
  }
  return options.inverse(this)
})
Handlebars.registerHelper('keyExist', function (array, key) {
  var options = arguments[arguments.length - 1]
  if (array[key] !== undefined) {
    return options.fn(this)
  }
  return options.inverse(this)
})

Handlebars.registerHelper('keyNotExist', function (array, key) {
  var options = arguments[arguments.length - 1]
  if (array[key] !== undefined) {
    return options.fn(this)
  }
  return options.fn(this)
})

Handlebars.registerHelper('toFrenchDay', function (timestamp) {
  if (timestamp) {
    moment.relativeTimeThreshold('d', 80000)
    return moment(timestamp).fromNow()
  }
})

Handlebars.registerHelper('ifOr', function (v1, v2, options) {
  if (v1 || v2) {
    return options.fn(this)
  }
  return options.inverse(this)
})

Handlebars.registerHelper('ifCond', function (v1, v2, v3) {
  var options = arguments[arguments.length - 1]
  if ((v1 === v2) || (v3 && v1 === v3)) {
    return options.fn(this)
  }
  return options.inverse(this)
})
Handlebars.registerHelper('ifNotEqual', function (v1, v2) {
  var options = arguments[arguments.length - 1]
  if ((v1 !== v2)) {
    return options.fn(this)
  }
  return options.inverse(this)
})

Handlebars.registerHelper('ifEqual', function (v1, v2) {
  var options = arguments[arguments.length - 1]
  if ((v1 === v2)) {
    return options.fn(this)
  }
  return options.inverse(this)
})

Handlebars.registerHelper('ifNotEmpty', function (v1) {
  var options = arguments[arguments.length - 1]
  if ((v1 === '') || (v1 === null)) {
    return options.fn(this)
  }
  return options.inverse(this)
})

Handlebars.registerHelper('ifEmpty', function (v1) {
  var options = arguments[arguments.length - 1]
  if ((v1 === '') || (v1 === null)) {
    return options.inverse(this)
  }
  return options.fn(this)
})

Handlebars.registerHelper('ifReg', function (reg, val) {
  var options = arguments[arguments.length - 1]

  var r = new RegExp(reg, 'i')

  if (r.test(val)) {
    return options.fn(this)
  }
  return options.inverse(this)
})

Handlebars.registerHelper('random', function (div) {
  return Math.floor((Math.random() * 10000) + 1)
})

Handlebars.numberFormat = function numberFormat (number, dec, dsep, tsep) {
  if (isNaN(number) || number == null) return ''
  number = 1 * number
  number = number.toFixed(~~dec)
  tsep = typeof tsep === 'string' ? tsep : ' '

  var parts = number.split('.')
  var fnums = parts[0]
  var decimals = parts[1] ? (dsep || '.') + parts[1] : ''

  return fnums.replace(/(\d)(?=(?:\d{3})+$)/g, '$1' + tsep) + decimals
}

Handlebars.registerHelper('numberFormat', function (number, dec, dsep, tsep) {
  return Handlebars.numberFormat(number, dec, dsep, tsep)
})

// Arrondir a 3 chiffres apres la virgule
Handlebars.registerHelper('round3', function (value) {
  return Handlebars.numberFormat(value, 3)
})

// Arrondir a 2 chiffres apres la virgule
Handlebars.registerHelper('round2', function (value) {
  if (value == null) {
    return "0.00"
  }
  return Handlebars.numberFormat(value, 2)
})

// Arrondir a 2 chiffres apres la virgule sans formatage
Handlebars.registerHelper('round2NoFormat', function (value) {
  if (value == null) {
    return "0.00"
  }
  return Handlebars.numberFormat(value, 2 , '.', '');
})

// Arrondir a 0 chiffres apres la virgule
Handlebars.registerHelper('round0', function (value) {
  return Handlebars.numberFormat(value, 0)
})

Handlebars.euros = function (value, precision) {
  if (isNaN(precision)) precision = 2
  // if (value === 0 || value === null) return '- €'
  return Handlebars.numberFormat(value, precision, ',', ' ') + (value ? ' €' : '')
}

Handlebars.registerHelper('euros', function (value, p) {
  return Handlebars.euros(value, p)
})

Handlebars.registerHelper('bulle', function (txt) {
  return new Handlebars.SafeString('rel="popover-hover" data-container="body" data-placement="top" data-content="' + txt + '"')
})

Handlebars.registerHelper('tooltip', function (txt) {
  return new Handlebars.SafeString('rel="tooltip" data-toggle="tooltip" data-container="body" data-placement="top" data-original-title="' + txt + '"')
})

Handlebars.registerHelper('html', function (html) {
  return new Handlebars.SafeString(html)
})

Handlebars.registerHelper('forPage', function (from, to, incr, page, block) {
  var accum = ''
  for (var i = from; i < to; i += incr) {
    var tmp = block.fn(i)
    if (page === i) {
      tmp = tmp.replace('<option', '<option selected="selected"')
    }
    accum += tmp
  }
  return accum
})

Handlebars.registerHelper('math', function (lvalue, operator, rvalue, options) {
  if (!lvalue) lvalue = 0
  if (!rvalue) rvalue = 0

  lvalue = parseFloat(lvalue)
  rvalue = parseFloat(rvalue)

  return {
    '+': lvalue + rvalue,
    '-': lvalue - rvalue,
    '*': parseFloat(lvalue * rvalue),
    '/': lvalue / rvalue,
    '%': lvalue % rvalue
  }[operator].toString()
});
Handlebars.registerHelper('percent', function (lvalue, rvalue) {
  if (!lvalue) lvalue = 0
  if (!rvalue) rvalue = 0

  lvalue = parseFloat(lvalue)
  rvalue = parseFloat(rvalue)
  let pourcent = (lvalue / rvalue) * 100
  return Math.round(pourcent)
});

Handlebars.registerHelper('selectedPage', function (page_en_cours, page_xhr) {
  page_en_cours = parseInt(page_en_cours)
  page_xhr = parseInt(page_xhr)

  return new Handlebars.SafeString(page_en_cours == page_xhr ? "selected='true'" : "");
});

(function () {
  var positionCounter = 0
  Handlebars.registerHelper('resetPosition', function () {
    positionCounter = 0
  })
  Handlebars.registerHelper('position', function () {
    return positionCounter
  })
  Handlebars.registerHelper('positionPlus', function () {
    positionCounter++
  })
  Handlebars.registerHelper('ifSuperieur', function (v1, v2, options) {
    if (parseFloat(v1) > parseFloat(v2)) {
      return options.fn(this)
    }
    return options.inverse(this)
  })
  Handlebars.registerHelper('ifInferieur', function (v1, v2, options) {
    if (parseFloat(v1) < parseFloat(v2)) {
      return options.fn(this)
    }
    return options.inverse(this)
  })
  Handlebars.registerHelper('ifPositionSuperieur', function (v1, options) {
    if (positionCounter > v1) {
      return options.fn(this)
    }
    return options.inverse(this)
  })
})();

(function () {
  var totaux = {}
  Handlebars.registerHelper('resetTotaux', function () {
    totaux = {}
  })
  Handlebars.registerHelper('totauxGet', function (indice, type) {
    if (Handlebars[type]) return Handlebars[type](totaux[indice])
    return totaux[indice]
  })
  Handlebars.registerHelper('totauxPlus', function (indice, valeur) {
    totaux[indice] = totaux[indice] || 0
    totaux[indice] += 1 * valeur
  })
})()

// Retourne un numéro de page
Handlebars.registerHelper('perPage', function (n, perPage) {
  return Math.floor(n / perPage)
})

function escapeRegExp (str) {
  return str.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, '\\$1')
}

// Mettre en valeur un terme
Handlebars.highlight = function (s, kw) {
  var mots = kw.replace(new RegExp(escapeRegExp('"'), 'g'), '')
  mots = mots.toLowerCase().split(' ')
  var m = []
  for (var idx in mots) {
    if (mots[idx].length > 0) {
      m.push(mots[idx])
    }
  }
  for (var idx2 in m) {
    s = s.replace(new RegExp('(' + m[idx2] + ')', 'gi'), '<span class="highlight">$1</span>')
  }
  return new Handlebars.SafeString(s)
}
Handlebars.registerHelper('highlight', Handlebars.highlight)

// Retourne un numéro de page
Handlebars.registerHelper('formatText', function (s) {
  if (s) {
    return new Handlebars.SafeString(s.replace(new RegExp('\r?\n', 'g'), '<br />'))
  } else {
    return
  }
})

Handlebars.registerHelper('log', function (something) {
  console.log(something)
})

Handlebars.registerHelper('bigNumber', function (value) {
  var val
  if (typeof (value) === 'string') {
    val = parseFloat(value.replace(' ', ''))
  } else {
    val = value
  }

  if (val > 1000) {
    val = ((val / 1000).toFixed(1)).toString()
    val = val.replace('.', ',')
    return val + ' K'
  } else {
    return value + ' '
  }
})

Handlebars.registerHelper('truncate', function (s, length, start) {
  if (start) start = 0
  if (s.length < length) {
    return new Handlebars.SafeString(s)
  } else {
    return new Handlebars.SafeString(s.substr(start, length)) + '...'
  }
})

Handlebars.registerHelper('convertUptime', function (seconds) {
  var numdays = Math.floor(seconds / 86400);
  var numhours = Math.floor((seconds % 86400) / 3600);
  var numminutes = Math.floor(((seconds % 86400) % 3600) / 60);
  var numseconds = ((seconds % 86400) % 3600) % 60;

  var toReturn = numdays > 0 ? numdays + "j " : "";
  toReturn += numhours > 0 ? numhours + "h " : "";
  toReturn += numminutes > 0 ? numminutes + "m " : "";
  return toReturn // + numseconds + "seconds";
})

// Ajouter les classes bootstrap hidden des devices
Handlebars.registerHelper('hidden', function (devices) {
  if (devices) {
    devices = devices.split(',')
    var cls = ''
    for (var i in devices) {
      cls += ' hidden-' + devices[i]
    }
    return cls
  }
})

Handlebars.registerHelper('iconModule', function (mod) {
  if (mod) {
    let html
    switch (mod) {
      case 'hotline':
        html = '<i class="fa fa-ambulance fa-lg"></i> '
        break
      case 'contact':
        html = '<i class="fa fa-vcard fa-lg"></i> '
        break
      case 'facture':
        html = '<i class="fa fa-euro fa-lg"></i> '
        break
      case 'facture-payee':
        html = '<i class="fa fa-euro text-success fa-lg"></i> '
        break
      case 'facture-impayee':
        html = `<span class="fa-stack fa-lg">
                  <i class="fa fa-times fa-stack-1x text-danger"></i>
                  <i class="fa fa-euro fa-stack-1x"></i>
                </span>`
        break
    }
    if (html) return new Handlebars.SafeString(html)
  }
})

